module.exports = __webpack_public_path__ + "static/media/jainy.7d24e7ee.png";